import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addTransportFeeCollection, getRoute } from "../../store/slices/fees";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStudent } from "../../store/slices/student";


export default function TransportFeesCollection() {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const [errors, setErrors] = useState({});
  const sessions = Array.from({ length: 2 }, (_, index) => {
    const startYear = currentYear - 1 + index;
    const endYear = String(startYear + 1).slice(-2);

    return `${startYear}-${endYear}`;
  });

  const [session, setSession] = useState("");
  const [standardId, setStandardId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [standards, setStandards] = useState([]);
  const [students, setStudents] = useState([]);
  const [sections, setSections] = useState([]);
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [routeId, setRouteId] = useState("");
  const [routes, setRoutes] = useState([]);
  const [numberOfMonths, setNumberOfMonths] = useState("");
  const [paidAmount, setPaidAmount] = useState("");
  const [discount, setDiscount] = useState("");
  const [discountFrom, setDiscountFrom] = useState("");
  const [remarks, setRemarks] = useState("");
  const [routeAmount, setRouteAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);


  useEffect(() => {

    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {

        setStandards(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

    dispatch(getRoute())
      .unwrap()
      .then((res) => {
        setRoutes(res.data || []);
      })
      .catch((err) => {
        toast.error(err);
      });

  }, []);

  const validate = () => {
    const newErrors = {};

    if (!session)
      newErrors.session = "Please select session";

    if (!standardId)
      newErrors.standardId = "Please select standard";

    if (!sectionId)
      newErrors.sectionId = "Please select section";

    if (!studentId)
      newErrors.studentId = "Please select student";

    if (!modeOfPayment)
      newErrors.modeOfPayment = "Please select payment mode";

    if (!paymentDate)
      newErrors.paymentDate = "Please select payment date";
    if (!routeId)
      newErrors.routeId = "Please select route";

    if (!numberOfMonths)
      newErrors.numberOfMonths = "Please enter number of months";

    if (Number(numberOfMonths) > 12)
      newErrors.numberOfMonths = "Maximum 12 months";

    if (!paidAmount)
      newErrors.paidAmount = "Please enter paid amount";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleStandardChange = (e) => {

    const value = e.target.value;

    setStandardId(value);

    setSectionId("");

    setStudentId("");

    setStudents([]);

    const selectedStandard = standards.find(
      item => item.standardId._id === value
    );

    if (selectedStandard) {
      setSections(selectedStandard.sectionId);
    } else {
      setSections([]);
    }

  };

  const handleSectionChange = (e) => {

    const value = e.target.value;

    setSectionId(value);

    setStudentId("");

    dispatch(getStudent({
      standardId,
      sectionId: value
    }))
      .unwrap()
      .then((res) => {

        setStudents(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  };

  const handleStudentChange = (e) => {

    setStudentId(e.target.value);


  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!validate())
      return;

    const payload = {

      session,

      studentId,

      routeId,

      numberOfMonths: Number(numberOfMonths),

      paidAmount: Number(paidAmount),

      discount: Number(discount),

      discountFrom,

      modeOfPayment,

      paymentDate,

      remarks

    };

    dispatch(addTransportFeeCollection(payload))

      .unwrap()

      .then(() => {

        toast.success("Transport fee collected successfully.");

        setTimeout(() => {

          window.location.reload();

        }, 1000);

      })

      .catch(err => {

        toast.error(err);

      });

  };
  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/accounts/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>
            <FiChevronRight className="separator" />

            <span className="active">Transport Fees Collection</span>
          </div>
        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSave}>
          <Row className="g-3 align-content-center justify-content-center">

            {/* Session */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Session</Form.Label>
                <Form.Select
                  value={session}

                  onChange={(e) => {
                    setSession(e.target.value);

                    setErrors((prev) => ({
                      ...prev,
                      session: "",
                    }));
                  }}
                >
                  <option value="">Select Session</option>

                  {sessions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.session}
                </div>
              </Form.Group>
            </Col>

            {/* Standard */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>

                <Form.Select
                  value={standardId}
                  onChange={(e) => {
                    handleStandardChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      standardId: "",
                      sectionId: "",
                      studentId: "",
                    }));
                  }}
                >
                  <option value="">Select Standard</option>

                  {standards.map((item) => (

                    <option
                      key={item.standardId._id}
                      value={item.standardId._id}
                    >
                      {item.standardId.name}
                    </option>

                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.standardId}
                </div>
              </Form.Group>
            </Col>

            {/* Section */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Section</Form.Label>

                <Form.Select
                  value={sectionId}

                  onChange={(e) => {
                    handleSectionChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      sectionId: "",
                      studentId: "",
                    }));
                  }}
                >
                  <option value="">Select Section</option>

                  {sections.map((item) => (

                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.name}
                    </option>

                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.sectionId}
                </div>
              </Form.Group>
            </Col>

            {/* Student */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Student</Form.Label>

                <Form.Select
                  value={studentId}

                  onChange={(e) => {
                    handleStudentChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      studentId: "",
                    }));
                  }}
                >
                  <option value="">Select Student</option>

                  {students.map((item) => (
                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.name}
                    </option>
                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.routeId}
                </div>
              </Form.Group>
            </Col>


            <Col md={3}>
              <Form.Group>
                <Form.Label>Route</Form.Label>

                <Form.Select
                  value={routeId}
                  onChange={(e) => {

                    const value = e.target.value;

                    setRouteId(value);

                    const selected = routes.find(x => x._id === value);

                    if (selected) {

                      setRouteAmount(selected.amount);

                      if (numberOfMonths) {
                        setTotalAmount(
                          Number(selected.amount) *
                          Number(numberOfMonths)
                        );
                      }

                    }

                    setErrors(prev => ({
                      ...prev,
                      routeId: ""
                    }));

                  }}
                >
                  <option value="">Select Route</option>

                  {routes.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.routeName}
                    </option>
                  ))}
                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.studentId}
                </div>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>No. of Months</Form.Label>
                <Form.Control
                  type="text"
                  value={numberOfMonths}
                  placeholder="No. of Months"
                  onChange={(e) => {

                    const value = e.target.value.replace(/\D/g, "");

                    if (Number(value) > 12)
                      return;

                    setNumberOfMonths(value);

                    if (routeAmount) {

                      setTotalAmount(
                        Number(routeAmount) *
                        Number(value || 0)
                      );

                    }

                  }}
                />
                <div className="text-danger mt-1" >
                  {errors.numberOfMonths}
                </div>
              </Form.Group>
            </Col>


            <Col md={3}>
              <Form.Group>

                <Form.Label>Total Amount</Form.Label>

                <Form.Control

                  value={totalAmount}

                  readOnly

                />

              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>

                <Form.Label>Discount</Form.Label>

                <Form.Control

                  type="text"

                  value={discount}

                  onChange={(e) => {

                    const value = e.target.value.replace(/\D/g, "");

                    if (Number(value) + Number(paidAmount) > totalAmount)
                      return;

                    setDiscount(value);

                  }}

                  placeholder="Discount"

                />

              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>

                <Form.Label>Paid Amount</Form.Label>

                <Form.Control

                  type="text"

                  value={paidAmount}

                  onChange={(e) => {

                    const value = e.target.value.replace(/\D/g, "");

                    if (Number(value) + Number(discount) > totalAmount)
                      return;

                    setPaidAmount(value);

                  }}

                  placeholder="Paid Amount"

                />
                <div className="text-danger mt-1">
                  {errors.paidAmount}
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Mode of Payment</Form.Label>

                <Form.Select
                  value={modeOfPayment}

                  onChange={(e) => {
                    setModeOfPayment(e.target.value);

                    setErrors((prev) => ({
                      ...prev,
                      modeOfPayment: "",
                    }));
                  }}
                >
                  <option value="">Select Mode</option>

                  <option value="Cash">Cash</option>

                  <option value="UPI">UPI</option>

                  <option value="Card">Card</option>

                  <option value="Bank Transfer">
                    Bank Transfer
                  </option>

                  <option value="Cheque">
                    Cheque
                  </option>

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.modeOfPayment}
                </div>

              </Form.Group>
            </Col>



            <Col md={3}>
              <Form.Group>

                <Form.Label>Payment Date</Form.Label>

                <Form.Control
                  type="date"
                  value={paymentDate}
                  max={today}
                  isInvalid={!!errors.paymentDate}
                  onChange={(e) => {
                    setPaymentDate(e.target.value);

                    setErrors(prev => ({
                      ...prev,
                      paymentDate: ""
                    }));
                  }}
                />
                <div className="text-danger mt-1" >
                  {errors.paymentDate}
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <button
                type="submit"
                className="btn-submit mt-4"
                style={{ width: "150px" }}
              >
                Submit
              </button>
            </Col>


          </Row>

        </Form>
      </div>
    </>
  );
}